// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Common = require("../utils/Common.res.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Core__Result = require("@rescript/core/src/Core__Result.res.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var MM_wrk_pattern_search_v2_parser = require("./MM_wrk_pattern_search_v2_parser.res.js");

function getVarType(varTypes, $$var) {
  return Core__Option.getExn(varTypes[$$var], "No type is defiend for var " + $$var.toString());
}

function exprSymMatchesSeqConst(exprSym, seqConst, varTypes) {
  if (exprSym === seqConst) {
    return true;
  } else if (exprSym >= 0) {
    return getVarType(varTypes, exprSym) === seqConst;
  } else {
    return false;
  }
}

function countMinLen(seq) {
  return Core__Array.reduce(seq, 0, (function (sum, seq) {
                return sum + seq.minLen | 0;
              }));
}

function exprIncludesConstAdjSeq(expr, startIdx, maxIdx, seq, varTypes) {
  var begin = startIdx;
  var maxBegin = (maxIdx + 1 | 0) - seq.length | 0;
  var matched = false;
  var maxSeqI = seq.length - 1 | 0;
  while(begin <= maxBegin && !matched) {
    matched = true;
    var exprI = begin;
    var seqI = 0;
    while(seqI <= maxSeqI && matched) {
      var seqSym = seq[seqI];
      var exprSym = expr[exprI];
      var seqConst = seqSym.constOrVar;
      matched = seqConst.TAG === "Const" ? exprSymMatchesSeqConst(exprSym, seqConst._0, varTypes) : exprSym >= 0 && getVarType(varTypes, exprSym) === seqConst._0.typ;
      exprI = exprI + 1 | 0;
      seqI = seqI + 1 | 0;
    };
    if (!matched) {
      begin = begin + 1 | 0;
    }
    
  };
  if (matched) {
    return begin + maxSeqI | 0;
  } else {
    return -1;
  }
}

function getMinIdxForSingleStmt(stmtI, exprLen, target, frmData) {
  switch (target) {
    case "Frm" :
        return frmData.stmtBnds[stmtI];
    case "Hyps" :
        if (stmtI === frmData.numOfHyps) {
          return exprLen;
        } else {
          return frmData.stmtBnds[stmtI];
        }
    case "Asrt" :
        if (stmtI === frmData.numOfHyps) {
          return frmData.stmtBnds[stmtI];
        } else {
          return exprLen;
        }
    
  }
}

function getMaxIdxForSingleStmt(stmtI, exprLen, target, frmData) {
  switch (target) {
    case "Frm" :
        return Core__Option.mapOr(frmData.stmtBnds[stmtI + 1 | 0], exprLen - 1 | 0, (function (nextStmtStart) {
                      return nextStmtStart - 1 | 0;
                    }));
    case "Hyps" :
        if (stmtI === frmData.numOfHyps) {
          return -1;
        } else {
          return frmData.stmtBnds[stmtI + 1 | 0] - 1 | 0;
        }
    case "Asrt" :
        if (stmtI === frmData.numOfHyps) {
          return exprLen - 1 | 0;
        } else {
          return -1;
        }
    
  }
}

function getMinIdxForNonSingleStmt(exprLen, target, frmData) {
  switch (target) {
    case "Frm" :
        return 0;
    case "Hyps" :
        if (frmData.numOfHyps > 0) {
          return 0;
        } else {
          return exprLen;
        }
    case "Asrt" :
        return frmData.stmtBnds[frmData.numOfHyps];
    
  }
}

function getMaxIdxForNonSingleStmt(exprLen, target, frmData) {
  switch (target) {
    case "Hyps" :
        if (frmData.numOfHyps > 0) {
          return frmData.stmtBnds[frmData.numOfHyps] - 1 | 0;
        } else {
          return -1;
        }
    case "Frm" :
    case "Asrt" :
        return exprLen - 1 | 0;
    
  }
}

function getStmtIForNonSingleStmt(target, frmData) {
  switch (target) {
    case "Frm" :
        return frmData.numOfHyps + 2 | 0;
    case "Hyps" :
        return frmData.numOfHyps + 1 | 0;
    case "Asrt" :
        return frmData.numOfHyps;
    
  }
}

function exprIncludesConstSeqWithTarget(expr, startIdx, maxIdx, seq, varTypes, frmData, stmtI) {
  var exprLen = expr.length;
  var target = seq.target;
  if (stmtI <= frmData.numOfHyps) {
    return exprIncludesConstSeq(expr, startIdx, maxIdx, seq, varTypes, frmData, stmtI);
  }
  if (seq.singleStmt) {
    var stmtI$1 = 0;
    var lastMatchedIdx = -1;
    while(stmtI$1 <= frmData.numOfHyps && lastMatchedIdx < 0) {
      var newStartIdx = Math.max(startIdx, getMinIdxForSingleStmt(stmtI$1, exprLen, target, frmData));
      var newMaxIdx = Math.min(maxIdx, getMaxIdxForSingleStmt(stmtI$1, exprLen, target, frmData));
      if (newStartIdx <= newMaxIdx) {
        lastMatchedIdx = exprIncludesConstSeq(expr, newStartIdx, newMaxIdx, seq, varTypes, frmData, stmtI$1);
      }
      stmtI$1 = stmtI$1 + 1 | 0;
    };
    return lastMatchedIdx;
  }
  var newStartIdx$1 = Math.max(startIdx, getMinIdxForNonSingleStmt(exprLen, target, frmData));
  var newMaxIdx$1 = Math.min(maxIdx, getMaxIdxForNonSingleStmt(exprLen, target, frmData));
  if (newStartIdx$1 <= newMaxIdx$1) {
    return exprIncludesConstSeq(expr, newStartIdx$1, newMaxIdx$1, seq, varTypes, frmData, getStmtIForNonSingleStmt(target, frmData));
  } else {
    return -1;
  }
}

function exprIncludesConstSeq(expr, startIdx, maxIdx, seq, varTypes, frmData, stmtI) {
  if (maxIdx < startIdx || seq.minConstMismatchIdx[stmtI] <= startIdx) {
    return -1;
  }
  var seq$1 = seq.elems;
  var res;
  switch (seq$1.TAG) {
    case "Adjacent" :
        res = exprIncludesConstAdjSeq(expr, startIdx, maxIdx, seq$1._0, varTypes);
        break;
    case "Ordered" :
        res = exprIncludesConstOrderedSeq(expr, startIdx, maxIdx, seq$1._0, varTypes, frmData, stmtI);
        break;
    case "Unordered" :
        res = exprIncludesConstUnorderedSeq(expr, startIdx, maxIdx, seq$1._0, varTypes, [], frmData, stmtI);
        break;
    case "OneOf" :
        res = exprIncludesConstOneOfSeq(expr, startIdx, maxIdx, seq$1._0, varTypes, frmData, stmtI);
        break;
    
  }
  if (res < 0) {
    seq.minConstMismatchIdx[stmtI] = startIdx;
  }
  return res;
}

function exprIncludesConstOrderedSeq(expr, startIdx, maxIdx, childElems, varTypes, frmData, stmtI) {
  var lastMatchedIdx = startIdx - 1 | 0;
  var matched = true;
  var i = 0;
  var maxI = childElems.length - 1 | 0;
  while(i <= maxI && matched) {
    lastMatchedIdx = exprIncludesConstSeqWithTarget(expr, lastMatchedIdx + 1 | 0, maxIdx, childElems[i], varTypes, frmData, stmtI);
    matched = 0 <= lastMatchedIdx && lastMatchedIdx <= maxIdx;
    i = i + 1 | 0;
  };
  if (matched) {
    return lastMatchedIdx;
  } else {
    return -1;
  }
}

function exprIncludesConstUnorderedSeq(expr, startIdx, maxIdx, childElems, varTypes, passedSeqIdxs, frmData, stmtI) {
  if (passedSeqIdxs.length === childElems.length) {
    return startIdx - 1 | 0;
  }
  var res = -1;
  var i = 0;
  var maxI = childElems.length - 1 | 0;
  while(res < 0 && i <= maxI) {
    if (!passedSeqIdxs.includes(i)) {
      var curSeq = childElems[i];
      if (startIdx < curSeq.minConstMismatchIdx[stmtI]) {
        var lastMatchedIdx = exprIncludesConstSeqWithTarget(expr, startIdx, maxIdx, curSeq, varTypes, frmData, stmtI);
        if (0 <= lastMatchedIdx && lastMatchedIdx <= maxIdx) {
          passedSeqIdxs.push(i);
          res = exprIncludesConstUnorderedSeq(expr, lastMatchedIdx + 1 | 0, maxIdx, childElems, varTypes, passedSeqIdxs, frmData, stmtI);
          passedSeqIdxs.pop();
        }
        
      }
      
    }
    i = i + 1 | 0;
  };
  return res;
}

function exprIncludesConstOneOfSeq(expr, startIdx, maxIdx, childElems, varTypes, frmData, stmtI) {
  var res = -1;
  var i = 0;
  var maxI = childElems.length - 1 | 0;
  while(res < 0 && i <= maxI) {
    var curSeq = childElems[i];
    if (startIdx < curSeq.minConstMismatchIdx[stmtI]) {
      var lastMatchedIdx = exprIncludesConstSeqWithTarget(expr, startIdx, maxIdx, curSeq, varTypes, frmData, stmtI);
      if (0 <= lastMatchedIdx && lastMatchedIdx <= maxIdx) {
        res = lastMatchedIdx;
      }
      
    }
    i = i + 1 | 0;
  };
  return res;
}

function exprIncludesVarSeqWithTarget(expr, startIdx, maxIdx, seq, varTypes, frmData, next, stop, stmtI) {
  var exprLen = expr.length;
  var target = seq.target;
  if (stmtI <= frmData.numOfHyps) {
    return exprIncludesVarSeq(expr, startIdx, maxIdx, seq, varTypes, next, stop, frmData, stmtI);
  }
  if (seq.singleStmt) {
    var stmtI$1 = 0;
    while(stmtI$1 <= frmData.numOfHyps && !stop.contents) {
      var newStartIdx = Math.max(startIdx, getMinIdxForSingleStmt(stmtI$1, exprLen, target, frmData));
      var newMaxIdx = Math.min(maxIdx, getMaxIdxForSingleStmt(stmtI$1, exprLen, target, frmData));
      if (newStartIdx <= newMaxIdx) {
        exprIncludesVarSeq(expr, newStartIdx, newMaxIdx, seq, varTypes, next, stop, frmData, stmtI$1);
      }
      stmtI$1 = stmtI$1 + 1 | 0;
    };
    return ;
  }
  var newStartIdx$1 = Math.max(startIdx, getMinIdxForNonSingleStmt(exprLen, target, frmData));
  var newMaxIdx$1 = Math.min(maxIdx, getMaxIdxForNonSingleStmt(exprLen, target, frmData));
  if (newStartIdx$1 <= newMaxIdx$1) {
    return exprIncludesVarSeq(expr, newStartIdx$1, newMaxIdx$1, seq, varTypes, next, stop, frmData, stmtI);
  }
  
}

function exprIncludesVarSeq(expr, startIdx, maxIdx, seq, varTypes, next, stop, frmData, stmtI) {
  if (!(startIdx <= maxIdx && startIdx < seq.minConstMismatchIdx[stmtI])) {
    return ;
  }
  var seq$1 = seq.elems;
  switch (seq$1.TAG) {
    case "Adjacent" :
        var seq$2 = seq$1._0;
        var begin = startIdx;
        var maxBegin = (maxIdx + 1 | 0) - seq$2.length | 0;
        var matched = false;
        var maxSeqI = seq$2.length - 1 | 0;
        while(begin <= maxBegin && !matched) {
          matched = true;
          var exprI = begin;
          var seqI = 0;
          while(seqI <= maxSeqI && matched) {
            var seqSym = seq$2[seqI];
            var exprSym = expr[exprI];
            var seqConst = seqSym.constOrVar;
            if (seqConst.TAG === "Const") {
              matched = exprSymMatchesSeqConst(exprSym, seqConst._0, varTypes);
            } else {
              var seqVar = seqConst._0;
              if (seqVar.capVar >= 0) {
                matched = seqVar.capVar === exprSym;
              } else if (exprSym >= 0 && !Core__Option.getExn(seqVar.capVars.contents[exprSym], "capVars.length is too small.") && getVarType(varTypes, exprSym) === seqVar.typ) {
                seqVar.capVar = exprSym;
                seqVar.capVars.contents[seqVar.capVar] = true;
                seqVar.capVarIdx = exprI;
              } else {
                matched = false;
              }
            }
            if (matched) {
              seqSym.matchedIdx = exprI;
            }
            exprI = exprI + 1 | 0;
            seqI = seqI + 1 | 0;
          };
          if (matched) {
            next({
                  matchBegin: begin,
                  matchEnd: begin + maxSeqI | 0
                });
          }
          seqI = Math.min(seqI, maxSeqI);
          while(seqI >= 0) {
            var seqSym$1 = seq$2[seqI];
            seqSym$1.matchedIdx = -1;
            var seqVar$1 = seqSym$1.constOrVar;
            if (seqVar$1.TAG !== "Const") {
              var seqVar$2 = seqVar$1._0;
              var exprIdx = begin + seqI | 0;
              if (exprIdx === seqVar$2.capVarIdx) {
                seqVar$2.capVars.contents[seqVar$2.capVar] = false;
                seqVar$2.capVar = -1;
              }
              
            }
            seqI = seqI - 1 | 0;
          };
          begin = begin + 1 | 0;
        };
        return ;
    case "Ordered" :
        return exprIncludesVarOrderedSeq(expr, startIdx, maxIdx, seq$1._0, varTypes, next, undefined, 0, stop, frmData, stmtI);
    case "Unordered" :
        return exprIncludesVarUnorderedSeq(expr, startIdx, maxIdx, seq$1._0, varTypes, [], next, undefined, stop, frmData, stmtI);
    case "OneOf" :
        var childElems = seq$1._0;
        var i = 0;
        var maxI = childElems.length - 1 | 0;
        while(!stop.contents && i <= maxI) {
          var curSeq = childElems[i];
          var begin$1 = {
            contents: startIdx
          };
          var beginMax = (maxIdx + 1 | 0) - curSeq.minLen | 0;
          while(!stop.contents && begin$1.contents <= beginMax && begin$1.contents < curSeq.minConstMismatchIdx[stmtI]) {
            var beginCopy = begin$1.contents;
            begin$1.contents = beginMax + 1 | 0;
            exprIncludesVarSeqWithTarget(expr, beginCopy, maxIdx, curSeq, varTypes, frmData, (function(begin$1){
                return function (curSeqRes) {
                  if (curSeqRes.matchEnd <= maxIdx) {
                    next(curSeqRes);
                    begin$1.contents = curSeqRes.matchBegin + 1 | 0;
                    return ;
                  }
                  
                }
                }(begin$1)), stop, stmtI);
          };
          i = i + 1 | 0;
        };
        return ;
    
  }
}

function exprIncludesVarOrderedSeq(expr, startIdx, maxIdx, childElems, varTypes, next, res, childElemIdx, stop, frmData, stmtI) {
  if (childElems.length <= childElemIdx) {
    if (res !== undefined) {
      return next({
                  matchBegin: res.matchBegin,
                  matchEnd: startIdx - 1 | 0
                });
    } else {
      return Js_exn.raiseError("exprIncludesVarOrderedSeq: res is None");
    }
  }
  if (startIdx > maxIdx) {
    return ;
  }
  var curSeq = childElems[childElemIdx];
  var begin = {
    contents: startIdx
  };
  var beginMax = (maxIdx + 1 | 0) - curSeq.minLen | 0;
  while(!stop.contents && begin.contents <= beginMax && begin.contents < curSeq.minConstMismatchIdx[stmtI]) {
    var beginCopy = begin.contents;
    begin.contents = beginMax + 1 | 0;
    exprIncludesVarSeqWithTarget(expr, beginCopy, maxIdx, curSeq, varTypes, frmData, (function(beginCopy){
        return function (curSeqRes) {
          if (curSeqRes.matchEnd <= maxIdx) {
            exprIncludesVarOrderedSeq(expr, curSeqRes.matchEnd + 1 | 0, maxIdx, childElems, varTypes, next, res !== undefined ? res : ({
                      matchBegin: beginCopy,
                      matchEnd: -1
                    }), childElemIdx + 1 | 0, stop, frmData, stmtI);
            begin.contents = curSeqRes.matchBegin + 1 | 0;
            return ;
          }
          
        }
        }(beginCopy)), stop, stmtI);
  };
}

function exprIncludesVarUnorderedSeq(expr, startIdx, maxIdx, childElems, varTypes, passedSeqIdxs, next, res, stop, frmData, stmtI) {
  if (passedSeqIdxs.length === childElems.length) {
    if (res !== undefined) {
      return next({
                  matchBegin: res.matchBegin,
                  matchEnd: startIdx - 1 | 0
                });
    } else {
      return Js_exn.raiseError("exprIncludesVarUnorderedSeq: res is None");
    }
  }
  if (startIdx > maxIdx) {
    return ;
  }
  var i = {
    contents: 0
  };
  var maxI = childElems.length - 1 | 0;
  while(!stop.contents && i.contents <= maxI) {
    if (!passedSeqIdxs.includes(i.contents)) {
      var curSeq = childElems[i.contents];
      var begin = {
        contents: startIdx
      };
      var beginMax = (maxIdx + 1 | 0) - curSeq.minLen | 0;
      while(!stop.contents && begin.contents <= beginMax && begin.contents < curSeq.minConstMismatchIdx[stmtI]) {
        var beginCopy = begin.contents;
        begin.contents = beginMax + 1 | 0;
        exprIncludesVarSeqWithTarget(expr, beginCopy, maxIdx, curSeq, varTypes, frmData, (function(begin,beginCopy){
            return function (curSeqRes) {
              if (curSeqRes.matchEnd <= maxIdx) {
                passedSeqIdxs.push(i.contents);
                exprIncludesVarUnorderedSeq(expr, curSeqRes.matchEnd + 1 | 0, maxIdx, childElems, varTypes, passedSeqIdxs, next, res !== undefined ? res : ({
                          matchBegin: beginCopy,
                          matchEnd: -1
                        }), stop, frmData, stmtI);
                passedSeqIdxs.pop();
                begin.contents = curSeqRes.matchBegin + 1 | 0;
                return ;
              }
              
            }
            }(begin,beginCopy)), stop, stmtI);
      };
    }
    i.contents = i.contents + 1 | 0;
  };
}

function getMatchedIndices(seq) {
  var indices = [];
  var go = function (seq) {
    var syms = seq.elems;
    if (syms.TAG === "Adjacent") {
      syms._0.forEach(function (sym) {
            if (sym.matchedIdx >= 0) {
              indices.push(sym.matchedIdx);
              return ;
            }
            
          });
      return ;
    }
    syms._0.forEach(go);
  };
  go(seq);
  indices.sort(Caml.int_compare);
  return indices;
}

function exprIncludesSeq(expr, seq, varTypes, frmData) {
  var res = {
    contents: undefined
  };
  var maxIdx = expr.length - 1 | 0;
  var stmtI = frmData.numOfHyps + 2 | 0;
  if (0 <= exprIncludesConstSeqWithTarget(expr, 0, maxIdx, seq, varTypes, frmData, stmtI)) {
    var stop = {
      contents: false
    };
    exprIncludesVarSeqWithTarget(expr, 0, maxIdx, seq, varTypes, frmData, (function (param) {
            stop.contents = true;
            var match = res.contents;
            if (match !== undefined) {
              return Js_exn.raiseError("next() is called twice in exprIncludesSeq.");
            } else {
              res.contents = getMatchedIndices(seq);
              return ;
            }
          }), stop, stmtI);
  }
  return res.contents;
}

function isAdj(flags) {
  return Core__Option.getOr(flags.adj, false);
}

function makeSym(symStr, symMap) {
  return {
          constOrVar: Core__Option.getExn(Belt_HashMapString.get(symMap, symStr), "makeSym: unknown symbol " + symStr),
          matchedIdx: -1
        };
}

function astToSymSeq(ast, parentFlags, symMap) {
  var flags = MM_wrk_pattern_search_v2_parser.passFlagsFromParentToChild(parentFlags, ast.flags);
  var match = flags.target;
  var target;
  if (match !== undefined) {
    switch (match) {
      case "Frm" :
          target = "Frm";
          break;
      case "Hyps" :
          target = "Hyps";
          break;
      case "Asrt" :
          target = "Asrt";
          break;
      
    }
  } else {
    target = "Frm";
  }
  var singleStmt = Core__Option.getOr(flags.singleStmt, false);
  var elems = astToSeqGrp(ast.elems, flags, target, singleStmt, symMap);
  var minLen;
  switch (elems.TAG) {
    case "Adjacent" :
        minLen = elems._0.length;
        break;
    case "Ordered" :
    case "Unordered" :
        minLen = countMinLen(elems._0);
        break;
    case "OneOf" :
        var symSeq = elems._0;
        minLen = Core__Array.reduce(symSeq, Core__Option.getOr(Core__Option.map(symSeq[0], (function (seq) {
                        return seq.minLen;
                      })), 0), (function (minLen, seq) {
                return Math.min(minLen, seq.minLen);
              }));
        break;
    
  }
  return {
          elems: elems,
          target: target,
          singleStmt: singleStmt,
          minLen: minLen,
          minConstMismatchIdx: []
        };
}

function astToSeqGrp(ast, flags, target, singleStmt, symMap) {
  switch (ast.TAG) {
    case "Symbols" :
        var syms = ast._0;
        if (isAdj(flags) || syms.length === 1) {
          return {
                  TAG: "Adjacent",
                  _0: syms.map(function (__x) {
                        return makeSym(__x, symMap);
                      })
                };
        } else {
          return {
                  TAG: "Ordered",
                  _0: syms.map(function (symStr) {
                        return {
                                elems: {
                                  TAG: "Adjacent",
                                  _0: [makeSym(symStr, symMap)]
                                },
                                target: target,
                                singleStmt: singleStmt,
                                minLen: 1,
                                minConstMismatchIdx: []
                              };
                      })
                };
        }
    case "Ordered" :
        return {
                TAG: "Ordered",
                _0: ast._0.map(function (__x) {
                      return astToSymSeq(__x, flags, symMap);
                    })
              };
    case "Unordered" :
        return {
                TAG: "Unordered",
                _0: ast._0.map(function (__x) {
                      return astToSymSeq(__x, flags, symMap);
                    })
              };
    case "OneOf" :
        return {
                TAG: "OneOf",
                _0: ast._0.map(function (__x) {
                      return astToSymSeq(__x, flags, symMap);
                    })
              };
    
  }
}

function traverseAst(seq, onSymSeqOpt, onSeqGrpOpt, onSymOpt) {
  var onSymSeq = onSymSeqOpt !== undefined ? onSymSeqOpt : (function (param) {
        
      });
  var onSeqGrp = onSeqGrpOpt !== undefined ? onSeqGrpOpt : (function (param) {
        
      });
  var onSym = onSymOpt !== undefined ? onSymOpt : (function (param) {
        
      });
  onSymSeq(seq);
  onSeqGrp(seq.elems);
  var syms = seq.elems;
  if (syms.TAG === "Symbols") {
    syms._0.forEach(onSym);
    return ;
  }
  syms._0.forEach(function (__x) {
        traverseAst(__x, onSymSeq, onSeqGrp, onSym);
      });
}

function traversePattern(seq, onSymSeqOpt, onSeqGrpOpt, onSymOpt) {
  var onSymSeq = onSymSeqOpt !== undefined ? onSymSeqOpt : (function (param) {
        
      });
  var onSeqGrp = onSeqGrpOpt !== undefined ? onSeqGrpOpt : (function (param) {
        
      });
  var onSym = onSymOpt !== undefined ? onSymOpt : (function (param) {
        
      });
  onSymSeq(seq);
  onSeqGrp(seq.elems);
  var syms = seq.elems;
  if (syms.TAG === "Adjacent") {
    syms._0.forEach(onSym);
    return ;
  }
  syms._0.forEach(function (__x) {
        traversePattern(__x, onSymSeq, onSeqGrp, onSym);
      });
}

function collectAllSeq(seq, allSeq) {
  traversePattern(seq, (function (s) {
          allSeq.push(s);
        }), undefined, undefined);
}

function makeSymMap(ast, ctx, capVars) {
  var symMap = Belt_HashMapString.make(20);
  var errors = [];
  traverseAst(ast.symSeq, undefined, undefined, (function (sym) {
          var match = MM_context.getTokenType(ctx, sym);
          if (match !== undefined) {
            switch (match) {
              case "C" :
                  if (!Belt_HashMapString.has(symMap, sym)) {
                    return Belt_HashMapString.set(symMap, sym, {
                                TAG: "Const",
                                _0: MM_context.ctxSymToIntExn(ctx, sym)
                              });
                  } else {
                    return ;
                  }
              case "V" :
                  if (!Belt_HashMapString.has(symMap, sym)) {
                    return Belt_HashMapString.set(symMap, sym, {
                                TAG: "Var",
                                _0: {
                                  typ: MM_context.getTypeOfVarExn(ctx, MM_context.ctxSymToIntExn(ctx, sym)),
                                  capVars: capVars,
                                  capVar: -1,
                                  capVarIdx: -1
                                }
                              });
                  } else {
                    return ;
                  }
              default:
                
            }
          }
          errors.push("'" + sym + "' is not a math symbol");
        }));
  if (errors.length === 0) {
    return {
            TAG: "Ok",
            _0: symMap
          };
  } else {
    return {
            TAG: "Error",
            _0: errors.join("; ")
          };
  }
}

function checkParenthesesMatch(tokens) {
  var parenCnt = 0;
  var i = 0;
  var maxI = tokens.length - 1 | 0;
  var mismatchFound = false;
  while(i <= maxI && !mismatchFound) {
    var tok = tokens[i];
    if (tok.startsWith(MM_wrk_pattern_search_v2_parser.openParenthesis)) {
      parenCnt = parenCnt + 1 | 0;
    } else if (tok === MM_wrk_pattern_search_v2_parser.closeParenthesis) {
      parenCnt = parenCnt - 1 | 0;
      if (parenCnt < 0) {
        mismatchFound = true;
      }
      
    }
    i = i + 1 | 0;
  };
  if (mismatchFound) {
    return false;
  } else {
    return parenCnt === 0;
  }
}

function validatePattern(text, ctx) {
  var tokens = Common.getSpaceSeparatedValuesAsArray(text.trim());
  var errors = [];
  tokens.forEach(function (tok) {
        if (tok.includes("$")) {
          if (tok.startsWith("$")) {
            if (tok === MM_wrk_pattern_search_v2_parser.operatorOrdered || tok === MM_wrk_pattern_search_v2_parser.operatorUnordered || tok === MM_wrk_pattern_search_v2_parser.operatorOneOf || tok === MM_wrk_pattern_search_v2_parser.openParenthesis || tok === MM_wrk_pattern_search_v2_parser.closeParenthesis) {
              return ;
            }
            var flags = tok.substring(tok.startsWith(MM_wrk_pattern_search_v2_parser.openParenthesis) ? 2 : 1);
            if (flags.length <= 0) {
              return ;
            }
            var flagHyps = false;
            var flagHyp = false;
            var flagAsrt = false;
            var flagAdj = false;
            var flagNonAdj = false;
            var flagSingleStmt = false;
            var flagNegation = false;
            for(var i = 0 ,i_finish = flags.length; i < i_finish; ++i){
              var flag = flags.charAt(i);
              if (flag === MM_wrk_pattern_search_v2_parser.flagHyps) {
                flagHyps = true;
              } else if (flag === MM_wrk_pattern_search_v2_parser.flagHyp) {
                flagHyp = true;
              } else if (flag === MM_wrk_pattern_search_v2_parser.flagAsrt) {
                flagAsrt = true;
              } else if (flag === MM_wrk_pattern_search_v2_parser.flagAdj) {
                flagAdj = true;
              } else if (flag === MM_wrk_pattern_search_v2_parser.flagNonAdj) {
                flagNonAdj = true;
              } else if (flag === MM_wrk_pattern_search_v2_parser.flagSingleStmt) {
                flagSingleStmt = true;
              } else if (flag === MM_wrk_pattern_search_v2_parser.flagNegation) {
                flagNegation = true;
              } else {
                errors.push("'" + tok + "' - invalid flag '" + flag + "'");
              }
            }
            if ((flagHyps || flagHyp) && flagAsrt) {
              errors.push("'" + tok + "' - flags '" + MM_wrk_pattern_search_v2_parser.flagHyps + "', '" + MM_wrk_pattern_search_v2_parser.flagHyp + "', and '" + MM_wrk_pattern_search_v2_parser.flagAsrt + "' cannot be used together");
            }
            if (flagAdj && flagNonAdj) {
              errors.push("'" + tok + "' - flags '" + MM_wrk_pattern_search_v2_parser.flagAdj + "' and '" + MM_wrk_pattern_search_v2_parser.flagNonAdj + "' cannot be used together");
            }
            if ((tok.startsWith(MM_wrk_pattern_search_v2_parser.openParenthesis) || tok.startsWith(MM_wrk_pattern_search_v2_parser.closeParenthesis)) && flagNegation) {
              errors.push("'" + tok + "' - flag '" + MM_wrk_pattern_search_v2_parser.flagNegation + "' cannot be used with parentheses");
              return ;
            } else {
              return ;
            }
          }
          errors.push("'" + tok + "' - all control tokens must start with '$'");
          return ;
        }
        var match = MM_context.getTokenType(ctx, tok);
        if (match !== undefined) {
          switch (match) {
            case "C" :
            case "V" :
                return ;
            default:
              
          }
        }
        errors.push("'" + tok + "' - is not a constant or variable");
      });
  if (!checkParenthesesMatch(tokens)) {
    errors.push("parentheses mismatch");
  }
  if (tokens.length > 0) {
    var match = MM_wrk_pattern_search_v2_parser.isPatternBegin(tokens[0]);
    if (match !== undefined) {
      
    } else {
      Core__Option.forEach(Core__Array.reduceWithIndex(tokens, undefined, (function (found, tok, i) {
                  if (found !== undefined || i === 0) {
                    return found;
                  } else {
                    return MM_wrk_pattern_search_v2_parser.isPatternBegin(tok);
                  }
                })), (function (param) {
              errors.push("when multiple patterns are specified, each pattern must begin with $");
            }));
    }
  }
  if (errors.length === 0) {
    return ;
  } else {
    return errors.join("\n");
  }
}

function parsePattern(text, symMap, ctx) {
  var text$1 = text.trim();
  if (text$1.length === 0) {
    return {
            TAG: "Ok",
            _0: []
          };
  }
  var errors = Core__Option.flatMap(ctx, (function (ctx) {
          return validatePattern(text$1, ctx);
        }));
  if (errors !== undefined) {
    return {
            TAG: "Error",
            _0: errors
          };
  }
  var asts = MM_wrk_pattern_search_v2_parser.parsePattern(text$1);
  if (asts === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot parse the pattern '" + text$1 + "'"
          };
  }
  var subpatterns = asts.map(function (ast) {
        var symMap$1 = symMap !== undefined ? ({
              TAG: "Ok",
              _0: Caml_option.valFromOption(symMap)
            }) : makeSymMap(ast, Core__Option.getExn(ctx, "parsePattern: either symMap or ctx must be provided."), {
                contents: []
              });
        return Core__Result.map(symMap$1, (function (symMap) {
                      var capVars = Core__Option.mapOr(Belt_HashMapString.valuesToArray(symMap).find(function (constOrVar) {
                                if (constOrVar.TAG === "Const") {
                                  return false;
                                } else {
                                  return true;
                                }
                              }), {
                            contents: []
                          }, (function (constOrVar) {
                              if (constOrVar.TAG === "Const") {
                                return {
                                        contents: []
                                      };
                              } else {
                                return constOrVar._0.capVars;
                              }
                            }));
                      var res_neg = ast.neg;
                      var res_symSeq = astToSymSeq(ast.symSeq, ast.flags, symMap);
                      var res_allSeq = [];
                      var res = {
                        neg: res_neg,
                        symSeq: res_symSeq,
                        allSeq: res_allSeq,
                        capVars: capVars
                      };
                      collectAllSeq(res_symSeq, res_allSeq);
                      return res;
                    }));
      });
  return Core__Array.reduce(subpatterns, {
              TAG: "Ok",
              _0: []
            }, (function (acc, subpatRes) {
                if (acc.TAG === "Ok") {
                  var subpatArr = acc._0;
                  if (subpatRes.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: subpatRes._0
                          };
                  }
                  subpatArr.push(subpatRes._0);
                  return {
                          TAG: "Ok",
                          _0: subpatArr
                        };
                }
                var prevMsg = acc._0;
                if (subpatRes.TAG === "Ok") {
                  return {
                          TAG: "Error",
                          _0: prevMsg
                        };
                } else {
                  return {
                          TAG: "Error",
                          _0: prevMsg + "; " + subpatRes._0
                        };
                }
              }));
}

function convertMatchedIndices(frm, idxs) {
  var hyps = frm.hyps.filter(function (hyp) {
        return hyp.typ === "E";
      });
  var numOfHyps = hyps.length;
  var res = Core__Array.fromInitializer(numOfHyps + 1 | 0, (function (param) {
          return [];
        }));
  var idxI = 0;
  var maxIdxI = idxs.length - 1 | 0;
  var hypI = 0;
  var maxHypI = numOfHyps - 1 | 0;
  var hypLenSum = 0;
  while(hypI <= maxHypI) {
    var curHypLen = hyps[hypI].expr.length;
    var maxIdx = (hypLenSum + curHypLen | 0) - 1 | 0;
    var curResArr = res[hypI];
    var curIdx = idxs[idxI];
    while(Core__Option.mapOr(curIdx, false, (function(maxIdx){
          return function (curIdx) {
            return curIdx <= maxIdx;
          }
          }(maxIdx))) && idxI <= maxIdxI) {
      curResArr.push(Core__Option.getExn(curIdx, undefined) - hypLenSum | 0);
      idxI = idxI + 1 | 0;
      curIdx = idxs[idxI];
    };
    hypLenSum = hypLenSum + curHypLen | 0;
    hypI = hypI + 1 | 0;
  };
  var curResArr$1 = res[hypI];
  while(idxI <= maxIdxI) {
    curResArr$1.push(idxs[idxI] - hypLenSum | 0);
    idxI = idxI + 1 | 0;
  };
  return res;
}

function mergeMatchedIndices(idxs) {
  var numOfStmts = Core__Option.getExn(idxs[0], "mergeMatchedIndices: error 1").length;
  var res = Core__Array.fromInitializer(numOfStmts, (function (param) {
          return [];
        }));
  idxs.forEach(function (patIdxs) {
        patIdxs.forEach(function (stmtIdxs, stmtI) {
              Caml_splice_call.spliceObjApply(Core__Option.getExn(res[stmtI], "mergeMatchedIndices: error 2"), "push", [stmtIdxs]);
            });
      });
  res.forEach(function (stmtIdxs) {
        stmtIdxs.sort(Caml.int_compare);
      });
  return res;
}

function frameMatchesPattern(frm, pattern) {
  var frmData = MM_context.frmGetPatternSearchData(frm);
  var expr = frmData.allHypsAsrt;
  var exprLen = expr.length;
  pattern.allSeq.forEach(function (seq) {
        var maxStmtI = frmData.numOfHyps + 2 | 0;
        while(seq.minConstMismatchIdx.length <= maxStmtI) {
          seq.minConstMismatchIdx.push(exprLen);
        };
        for(var i = 0; i <= maxStmtI; ++i){
          seq.minConstMismatchIdx[i] = exprLen;
        }
      });
  if (pattern.capVars.contents.length < frm.varTypes.length) {
    pattern.capVars.contents = Core__Array.make(frm.varTypes.length, false);
  }
  var idxs = Core__Option.map(exprIncludesSeq(expr, pattern.symSeq, frm.varTypes, frmData), (function (__x) {
          return convertMatchedIndices(frm, __x);
        }));
  if (idxs !== undefined) {
    if (pattern.neg) {
      return ;
    } else {
      return idxs;
    }
  } else if (pattern.neg) {
    return convertMatchedIndices(frm, []);
  } else {
    return ;
  }
}

function frameMatchesPatterns(frm, patterns) {
  if (patterns.length === 0) {
    return {
            TAG: "Matched",
            _0: undefined
          };
  }
  var idxs = Core__Option.map(Core__Array.reduce(patterns, [], (function (idxs, pattern) {
              if (idxs === undefined) {
                return ;
              }
              var patIdxs = frameMatchesPattern(frm, pattern);
              if (patIdxs !== undefined) {
                idxs.push(patIdxs);
                return idxs;
              }
              
            })), mergeMatchedIndices);
  if (idxs !== undefined) {
    return {
            TAG: "Matched",
            _0: idxs
          };
  } else {
    return "NotMatched";
  }
}

exports.parsePattern = parsePattern;
exports.frameMatchesPatterns = frameMatchesPatterns;
exports.validatePattern = validatePattern;
exports.countMinLen = countMinLen;
exports.exprIncludesSeq = exprIncludesSeq;
exports.convertMatchedIndices = convertMatchedIndices;
exports.mergeMatchedIndices = mergeMatchedIndices;
/* Common Not a pure module */
